export enum RecruitmentStatusEnum {
    None = '',
    Completed = 'Completed',
    Terminated = 'Terminated',
}
